var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bk-header"},[_c('div',{staticClass:"bk-header__wrapper"},[_c('header',{ref:"header",staticClass:"bk-header__header max-w-3xl m-auto px-4 md:px-6 lg:px-10"},[_vm._t("logo"),_vm._v(" "),_vm._t("navigation"),_vm._v(" "),_vm._t("search"),_vm._v(" "),_vm._t("header-icons",null,null,{
          activeIcon: _vm.activeIcon,
        })],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }